const MuiSelect = {
  styleOverrides: {
    select: {
      minHeight: 'initial'
    }
  }
};
export default MuiSelect;